<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/tekhnicheskoe-diagnostirovanie/">Техническое освидетельствование опасных производственных объектов: технических устройств, зданий и сооружений
    </div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/tekhnicheskoe-diagnostirovanie/obsledovanie-sosudov/">Техническое освидетельствование сосудов работающих под давлением


    </div>
  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Техническое освидетельствование сосудов работающих под давлением
    </h1>
    <ul class="link-arrow">
      <li>- В Москве и регионах</li>
      <li>- Опытные эксперты</li>
      <li>- Строгое соблюдение сроков</li>
      <li>- Собственная ЛНК</li>
      <li>- Индивидуальный подход</li>
    </ul>

    <h2>Оборудование, работающее под давлением, включает:</h2>

    <ul class="marked ml-50">
      <li>сосуды, работающие под избыточным давлением газов, жидкостей и пара;</li>
      <li>цистерны, баллоны и бочки для сжиженных и пр. газов;</li>
      <li>барокамеры и другое.</li>
    </ul>

    <p>Согласно <strong>Федеральным нормам и правилам в области промышленной безопасности &quot;Правила промышленной безопасности при использовании оборудования, работающего под избыточным давлением&quot;</strong>, утвержденным приказом Федеральной службы по экологическому, технологическому и атомному надзору от 15 декабря 2020 года № 536, в процессе использования оборудование под давлением должно подвергаться обязательному освидетельствованию:</p>

    <ul class="marked ml-50">
      <li>до начала применения (первичное техническое освидетельствование сосудов);</li>
      <li>в процессе использования (периодическое освидетельствование сосудов под давлением);</li>
      <li>до наступления периодического освидетельствования в случаях, предусмотренных вышеуказанными федеральными нормами и правилами (внеочередное освидетельствование).</li>
    </ul>

    <p>А также <strong>техническому диагностированию</strong> в порядке контроля состояния оборудования и отдельных его элементов (для определения характера и размеров выявленных дефектов) и <strong>экспертизе промышленной безопасности</strong> (в ряде случаев, установленных Федеральным законом от 21.07.1997 N 116-ФЗ).</p>

    <p class="title__red">Специалисты ООО &laquo;Протос Экспертиза&raquo;:</p>

    <ul class="marked ml-50">
      <li>Проведут техническое освидетельствование сосудов, работающих под давлением, включая освидетельствование криогенных сосудов, в том числе с применением методов неразрушающего контроля;</li>
      <li>Внесут необходимые отметки (результаты) в техническую документацию и/или паспорт диагностируемого оборудования;</li>
      <li>Проведут экспертизу промышленной безопасности;</li>
      <li>Дадут подробные разъяснения по каждому этапу.</li>
    </ul>

    <p>Стоимость зависит от класса опасности ОПО и от объема выполняемых работ и рассчитывается индивидуально. Для получения окончательного расчета свяжитесь со специалистами нашей компании любым удобным для Вас способом.</p>
    <app-recall-form heading="У Вас есть вопросы? Наши специалисты Вас проконсультируют."></app-recall-form>
    <p><strong>Первичное освидетельствование,</strong> в том числе диагностирование криогенных сосудов, должно включать следующие мероприятия:</p>

    <ul class="marked ml-50">
      <li>Визуальный осмотр и измерительный контроль с внешних и с внутренних сторон (при их доступности);</li>
      <li>Контроль монтажа, обвязки трубопроводами и пр. на соответствие проектной документации;</li>
      <li>Контроль толщины стенок сосудов, работающих под давлением (в том случае, если это предусмотрено руководством по эксплуатации или проектной документацией);</li>
      <li>Гидравлические испытания.</li>
    </ul>

    <p><strong>Для проведения внеочередного технического освидетельствования требуется указать его причину.</strong> При этом плановые сроки проведения технического освидетельствования или диагностирования не изменятся.</p>

    <p><strong>Внеочередное техническое диагностирование или освидетельствование</strong> сосудов, работающих под давлением, производится в случае:</p>

    <ul class="marked ml-50">
      <li>их демонтажа и перемещения с последующей установкой на новом месте (за исключением транспортабельного оборудования без смены эксплуатирующей организации);</li>
      <li>осуществления ремонта сосудов с применением сварки, наплавки, термообработки (за исключением случаев, требующих последующую экспертизу промышленной безопасности);</li>
      <li>приостановки эксплуатации сосудов на год и более.</li>
    </ul>
    <app-atomka-calc heading="Получить консультацию эксперта и последующий расчет стоимости технического освидетельствования"></app-atomka-calc>
    <p><strong>ООО &laquo;Протос Экспертиза&raquo; работает в области промышленной безопасности более 20 лет. У нас большой опыт проведения технического освидетельствования, диагностирования и экспертизы промышленной безопасности. Собственная лаборатория неразрушающего контроля и строгое соблюдение сроков в рамках договорных обязательств.</strong></p>

    <app-reviews-block class="w-100"></app-reviews-block>
  </div>
</div>
<app-footer></app-footer>
